// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Monad_State_Trans = require("../Control.Monad.State.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semigroup_Foldable = require("../Data.Semigroup.Foldable/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Effect_Console = require("../Effect.Console/index.js");
var Effect_Unsafe = require("../Effect.Unsafe/index.js");
var Partial = require("../Partial/index.js");
var SG = function (x) {
    return x;
};
var $$while = function (dictMonad) {
    return function (dictMonoid) {
        return function (mp) {
            return function (ma) {
                return Control_Bind.bind(dictMonad.Bind1())(mp)(function (p) {
                    if (p) {
                        return Control_Apply.apply((dictMonad.Bind1()).Apply0())(Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(Data_Semigroup.append(dictMonoid.Semigroup0()))(ma))($$while(dictMonad)(dictMonoid)(mp)(ma));
                    };
                    return Control_Applicative.pure(dictMonad.Applicative0())(Data_Monoid.mempty(dictMonoid));
                });
            };
        };
    };
};
var unsafeFromJust = function (x) {
    return Data_Maybe.fromJust()(x);
};
var todo = function (dictWarn) {
    return Partial.crash()("Not implemented");
};
var semigroupSG = new Data_Semigroup.Semigroup(function (v) {
    return function (v1) {
        return function (f) {
            return f(v(f))(v1(f));
        };
    };
});
var repeatedly = function (n$prime) {
    return function (f) {
        return function (a$prime) {
            var go = function (v) {
                var $28 = v.n <= 0;
                if ($28) {
                    return new Control_Monad_Rec_Class.Done(v.a);
                };
                return new Control_Monad_Rec_Class.Loop({
                    n: v.n - 1 | 0,
                    a: f(v.a)
                });
            };
            return Control_Monad_Rec_Class.tailRec(go)({
                n: n$prime,
                a: a$prime
            });
        };
    };
};
var pop = function (f) {
    return Control_Bind.bind(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.get(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity)))(function (arr) {
        var v = Data_Array.findIndex(f)(arr);
        if (v instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Maybe.Nothing.value);
        };
        if (v instanceof Data_Maybe.Just) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity))(Control_Monad_State_Class.put(Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity))(unsafeFromJust(Data_Array.deleteAt(v.value0)(arr))))(function () {
                return Control_Applicative.pure(Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity))(Data_Array.index(arr)(v.value0));
            });
        };
        throw new Error("Failed pattern match at Extra.Prelude (line 175, column 3 - line 179, column 25): " + [ v.constructor.name ]);
    });
};
var newtypeSG = new Data_Newtype.Newtype(function (n) {
    return n;
}, SG);
var keyBy$prime = function (dictOrd) {
    return function (f) {
        return function (vs) {
            return Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(Control_Bind.bind(Control_Bind.bindArray)(vs)(function (v) {
                return Data_Maybe.maybe([  ])(function (k) {
                    return [ new Data_Tuple.Tuple(k, v) ];
                })(f(v));
            }));
        };
    };
};
var keyBy = function (dictOrd) {
    return function (f) {
        return function (vs) {
            return Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(Data_Array.zip(Data_Functor.map(Data_Functor.functorArray)(f)(vs))(vs));
        };
    };
};
var impossible = function (s) {
    var m = "But this was impossible!!! " + s;
    var v = Effect_Unsafe.unsafePerformEffect(Effect_Console.log(m));
    return Partial.crash()(m);
};
var groupToMap = function (dictFoldable) {
    return function (dictOrd) {
        return function (v) {
            var combine = function (v1) {
                return function (v2) {
                    if (v2 instanceof Data_Maybe.Just) {
                        return Data_Maybe.Just.create(v.merge(v.value(v1))(v2.value0));
                    };
                    if (v2 instanceof Data_Maybe.Nothing) {
                        return Data_Maybe.Just.create(v.value(v1));
                    };
                    throw new Error("Failed pattern match at Extra.Prelude (line 129, column 3 - line 129, column 37): " + [ v1.constructor.name, v2.constructor.name ]);
                };
            };
            return Data_Foldable.foldr(dictFoldable)(function (v1) {
                return function (m) {
                    return Data_Map_Internal.alter(dictOrd)(combine(v1))(v.key(v1))(m);
                };
            })(Data_Map_Internal.empty);
        };
    };
};
var groupBy$prime = function (f) {
    return function (xs) {
        return Data_Array.groupBy(Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Data_Functor.functorFn)(function (v) {
            return Data_Eq.eq(Data_Ordering.eqOrdering)(v)(Data_Ordering.EQ.value);
        }))(f))(Data_Array.sortBy(f)(xs));
    };
};
var foldr1 = function (dictFoldable1) {
    return function (f) {
        return function (xs) {
            return Data_Newtype.unwrap(newtypeSG)(Data_Semigroup_Foldable.foldMap1(dictFoldable1)(semigroupSG)(function ($43) {
                return SG(Data_Function["const"]($43));
            })(xs))(f);
        };
    };
};
var foldl1 = function (dictFoldable1) {
    return function (f) {
        return foldr1(dictFoldable1)(Data_Function.flip(f));
    };
};
var filterSet = function (dictOrd) {
    return function (f) {
        return Data_Function.flip(Data_Foldable.foldr(Data_Set.foldableSet))(Data_Set.empty)(function (x) {
            return function (set) {
                var $41 = f(x);
                if ($41) {
                    return Data_Set.insert(dictOrd)(x)(set);
                };
                return set;
            };
        });
    };
};
var countIf = function (dictFoldable) {
    return function (f) {
        return function (xs) {
            var g = function (x) {
                return function (acc) {
                    var $42 = f(x);
                    if ($42) {
                        return acc + 1 | 0;
                    };
                    return acc;
                };
            };
            return Data_Foldable.foldr(dictFoldable)(g)(0)(xs);
        };
    };
};
module.exports = {
    countIf: countIf,
    filterSet: filterSet,
    foldl1: foldl1,
    foldr1: foldr1,
    "groupBy'": groupBy$prime,
    groupToMap: groupToMap,
    keyBy: keyBy,
    "keyBy'": keyBy$prime,
    pop: pop,
    repeatedly: repeatedly,
    todo: todo,
    unsafeFromJust: unsafeFromJust,
    "while": $$while,
    impossible: impossible
};
